export enum NotificationType {
  Pending,
  Success,
  Info,
  Warning,
  Error,
}
